// Shared clan logic used by both backends. Membership/leaderboard SQL lives in
// the backends (it touches multiple tables); here we keep the pure constants and
// the clan-name validator so the rules are defined once.
import { containsProfanity } from "./profanity.js";

export const MAX_CLAN_MEMBERS = 20;
export const MAX_CLAN_NAME = 20;
// Flies charged to found a clan (refunded if creation fails on a name clash).
export const CLAN_COST = 100;

// Clan names are a bit more permissive than player names: spaces are allowed
// (e.g. "Lizard Squad"). Profanity is checked with containsProfanity, which
// strips spaces/underscores so spaced-out slurs are still caught.
const CLAN_NAME_RE = /^[A-Za-z0-9 _-]+$/;

// Returns the cleaned clan name, or null if empty / too long / bad charset /
// profane. The case-insensitive uniqueness key is `name.toLowerCase()`.
export function validateClanName(raw) {
  if (typeof raw !== "string") return null;
  const s = raw.replace(/\s+/g, " ").trim();
  if (s.length === 0 || s.length > MAX_CLAN_NAME) return null;
  if (!CLAN_NAME_RE.test(s)) return null;
  if (containsProfanity(s)) return null;
  return s;
}

export function clanNameKey(name) {
  return String(name).toLowerCase();
}

// Join modes:
//   public  — anyone can join from the clan list
//   request — players send a join request; the leader approves/denies
//   private — not publicly joinable; the leader adds members by name
export const CLAN_MODES = ["public", "request", "private"];

// Coerce arbitrary input to a valid mode, defaulting to "public".
export function normalizeClanMode(m) {
  return CLAN_MODES.includes(m) ? m : "public";
}
